import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f1576ef6&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "bootstrap-vue/dist/bootstrap-vue.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./App.vue?vue&type=style&index=2&id=f1576ef6&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports